module.exports = __webpack_public_path__ + "static/media/facebook_icon.77ed84c5.JPG";